import React from "react";
import "./Loader.scss";
const Loader = () => {
  return (
    <div className="custom_loader__component">
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading, please wait...</p>
      </div>
    </div>
  );
};

export default Loader;
